"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCard = void 0;
const MoonExpansion_1 = require("../moon/MoonExpansion");
const Card_1 = require("./Card");
class ProjectCard extends Card_1.Card {
    play(player) {
        const adjustedReserveUnits = MoonExpansion_1.MoonExpansion.adjustedReserveCosts(player, this);
        player.deductUnits(adjustedReserveUnits);
        return undefined;
    }
}
exports.ProjectCard = ProjectCard;
//# sourceMappingURL=ProjectCard.js.map